import React from 'react'
import { withTranslation } from 'react-i18next';
import Clip from '../../images/clip.svg';
import Parent from '../../common/parent';
import DropDown from "../../common/simple/dropDown";
import { constants } from '../../common/constants/constants';
import $ from "jquery";
import {BllinkLogger} from "../../common/utils/bllink_loggers";
import CacheData from "../../common/utils/cacheData";
import BankDetailsLogic from "./bankDetailsLogic";
import './bankDetails.css';
import {fileToBase64} from '../../../utils/fileToBase64';
import { translatesLegalInfoPages } from "../../common/constants/translatedLegalInfoLinks";

const ALLOWED_DOC_SIZE = 2;

class NewBankDetails extends Parent{

    constructor(props) {
        super(props);

        this.bindUploadDocument.bind(this);
        this.saveDetails.bind(this);
        this.onBankChangedFunc = this.onBankChanged.bind(this);

        const payload = CacheData.fetchCache('BankDetails', {typeOfCache: sessionStorage});
        const hasData = (payload && payload.bankDetails);
        if (hasData){
            this.state = {
                selectedBankCode: payload.bankDetails.bankCode,
                successUploading: payload.successUploading
            }
        }

    }
    async componentDidMount(){
        await this.verifyLoggedIn();
        this.bindUploadDocument();
        this.fillInDetailsIfPresent();
        BankDetailsLogic.validateCreateForm(null, this)
    }

    fillInDetailsIfPresent(){
        // fill in from cache
        const payload = CacheData.fetchCache('BankDetails', {typeOfCache: sessionStorage});
        if (payload && payload.bankDetails){
            BllinkLogger.info(`fill from cache`, payload)
            let bankDetails = payload.bankDetails;
            $('#account_id').val(bankDetails.accountID)
            $('#branch_number').val(bankDetails.branchNumber)
            $('#full-name').val(payload.fullName)
        }

    }

    onBankChanged(newBankCode){
        this.setState({
            selectedBankCode: newBankCode
        })
    }

    bindUploadDocument(){
        const thisObj = this;
        $(".js-upload-manager-photo").unbind('change').bind('change', function(){
            thisObj.readURL(this);
        });
    }


    async readURL(input) {
        const {t} = this.props;
        const thisObj = this;

        if (input.files && input.files[0]) {
            let sizeOfPhotoInMB = input.files[0].size / 1024 / 1024;
            BllinkLogger.info(`sizeOfPhotoInMB is `, sizeOfPhotoInMB);
            if (sizeOfPhotoInMB > ALLOWED_DOC_SIZE){
                alert(t('buildings.document_too_large'));
                return;
            }
            const imageBase64 = await fileToBase64(input.files[0]);
            const fileName = input.files[0].name;
            $('#name-of-document').html(fileName);
            // todo upload to a new route and save the result to the state
            await thisObj.uploadProofOfOwnerShip(thisObj, imageBase64, fileName);
        }
    }

    async uploadProofOfOwnerShip(thisObj, imageBase64, fileName){
        let buildingID = this.props.match.params.buildingID;
        thisObj.startLoader();
        const uploadResult = await thisObj.client.put(`/images/upload/${buildingID}`, { imageBase64, fileName });
        thisObj.endLoader();
        BllinkLogger.info(`uploadResult proof of ownership`, uploadResult);

        this.saveUploadToCache(uploadResult);

        // save result to payload
        thisObj.setState({
            successUploading: uploadResult.success
        })

    }

    saveUploadToCache(uploadResult){
        let options = {typeOfCache: sessionStorage};
        let payload = CacheData.fetchCache('BankDetails', options);
        payload = {
            ...payload,
            successUploading: uploadResult.success
        }

        CacheData.cache('BankDetails', payload, options)
    }

    async saveDetails(){
        /* just save to local storage. and move to next page */
        const {t} = this.props;
        let buildingID = this.props.match.params.buildingID;

        if (!this.state.successUploading){
            alert(t('buildings.must_upload_document'))
            return
        }

        let payload = this.buildPayload();

        CacheData.cache('BankDetails', payload, {typeOfCache: sessionStorage});

        this.props.history.push(`/${constants.pages.viewBankDetailsUrl}/${buildingID}`);
    }

    buildPayload(){

        let fullName = $('#full-name').val();
        let selectedBank = $('#bank-code option:selected');
        let bankCode = selectedBank.val();
        let bankName = selectedBank.html();
        let branchNumber = $('#branch_number').val();
        let accountID = $('#account_id').val();
        let currentPayload = CacheData.fetchCache('BankDetails', {typeOfCache: sessionStorage});
        let successUploading = currentPayload ? currentPayload.successUploading : false;

        let payload = {
            fullName: fullName,
            successUploading: successUploading,
            bankDetails: {
                bankCode: bankCode,
                bankName: bankName,
                branchNumber: branchNumber,
                accountID: accountID,
            }
        }

        BllinkLogger.info(`payload `, payload);

        return payload;
    }

    renderTitle(){

        const {t} = this.props;

        return (
            <section>
                <div className="container">
                    <div className="row">
                        <div className="bank_d col-md-12">
                            <h2 className="text-center">{t('buildings.add_bank_details_title')}</h2>
                            <p>{t('buildings.building_added')} <span role="img" aria-label="thumbs-up">&#128077;&#127996;</span> </p>
                            <p>{t('buildings.actions_left')}</p>
                            <p>{t('buildings.proof_of_ownership_title')}</p>
                        </div>
                    </div>
                </div>
            </section>
        )
    }


    render() {
        const {t} = this.props;

        if (!this.state.userCheck){
            return <div/>
        }
        
        return (
            <div>
                {this.renderTitle()}
                <section>
                    <div className="container">
                        <div className="col-md-12">
                            <div className="inner-bank_detail">
                                <form id={"js-add-bank-details-form"}>
                                    <div className="row">
                                        <div className="bank_detail_from">
                                            <div className="bank_form_1">
                                                <div className="form-group">
                                                    <label htmlFor="full-name">{t('buildings.bank_account_owner')}: *</label>
                                                    <input type="text" className="form-control" name="full-name"
                                                           id="full-name"
                                                           />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="last-name">{t('buildings.bank_name')}: * </label>
                                                    <DropDown
                                                        id="bank-code"
                                                        name="js-bank-code"
                                                        callingObj={this}
                                                        value={this.state.selectedBankCode}
                                                        onSelectChange={this.onBankChangedFunc}
                                                        options={this.bankOptions('ILS')} // TODO: get currency from building
                                                        includeEmptyOption={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="bank_form_2">
                                                <div className="form-group">
                                                    <label htmlFor="branch_number">{t('buildings.branch_number')}: * </label>
                                                    <input type="text" className="form-control" name="branch_number"
                                                           id="branch_number"/>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="password">{t('buildings.account_number')}: * </label>
                                                    <input type="text" className="form-control" name="account-number"
                                                           id="account_id"/>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center align-items-center">
                                                <div className="col-10">
                                                    <div className={"row"}>
                                                        <div className="inline_layout-37">
                                                            <label className="label_container-4">
                                                                <input type="checkbox" name={"terms-of-use"}/>
                                                                <span className="checkmark-4"/>
                                                                <a href={translatesLegalInfoPages.termsOfUseUrl.default}
                                                                   target={"_blank"}
                                                                   rel="noopener noreferrer"
                                                                >
                                                                    {t('buildings.terms_of_use')}
                                                                </a>
                                                            </label>
                                                        </div>
                                                    </div>

                                                    <div className={"row"}>
                                                        <img src={Clip} alt="upload cheque" id={"upload-doc-image"}/>
                                                        <span className={"cheque-text"}> {t('buildings.cheque_photo')} </span>
                                                        <input type="file" name="proof-of-ownership" id="imgInp" accept="image/*, application/pdf"
                                                               className={`file_upload-input js-upload-manager-photo clickable`} />
                                                        <p id={"name-of-document"}/>
                                                    </div>

                                                </div>


                                            </div>

                                        </div>
                                    </div>
                                    <div className="bank_btn_in">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                {/*<a href="/" className="bank_page_reture">{t('payments.back')}</a>*/}
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-group txt_gp">
                                                    <input type="submit" name="sign-in" id="bank_datail" value={t('buildings.confirm')}/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default withTranslation()(NewBankDetails)
